// extracted by mini-css-extract-plugin
export var backdropBlur = "_l7-0";
export var contentCard = "_l7-5";
export var frame = "_l7-2";
export var image = "_l7-4";
export var imagePane = "_l7-3";
export var modal = "_l7-1";